<template>
  <Dialog
    v-bind="$attrs"
    :persistent="dataLoading || saveInProgress"
  >
    <template
      v-if="dataLoading"
      #content
    >
      <div class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
        />
      </div>
    </template>
    <template
      v-else
      #content
    >
      <div v-if="orderStatusId === null">
        {{ $t("Order not found") }}
      </div>
      <OrderStatus
        v-else
        :statuses="statuses"
        :order="order"
        :save-in-progress="saveInProgress"
      />
    </template>

    <template
      v-if="dataLoading || orderStatusId === null"
      #actions
    >
      &nbsp;
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { computed, useAttrs } from "vue"
import Dialog from "@/components/dialogs/Dialog.vue"
import OrderStatus from "@/components/orders/OrderStatus.vue"
import { Order } from "@/entities/order";

defineOptions({ name: "StatusChangeDialog", inheritAttrs: false })

const props = defineProps<{
  statuses?: OrderStatus[]
  dataLoading: boolean
  order: Order | null;
}>();

const orderStatusId = computed<string | null>(() =>
  props.order?.statusId ?? null
)

const saveInProgress = computed<boolean>(() => {
  const attrs = useAttrs()
  return !!attrs["save-in-progress"]
})
</script>
